import React from 'react';
import cn from 'classnames';

import css from './Button.module.scss';

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  className?: string;
  children?: React.ReactNode;
  ref?: React.Ref<HTMLButtonElement>;
}

export const Button: React.FC<Props> = ({ className, children, ref, ...rest }) => {
  return (
    <button className={cn(css.btn, className)} ref={ref} {...rest}>
      {children}
    </button>
  );
};
